import MuiPaper from "@mui/material/Paper";
const Paper = MuiPaper;
export default Paper;
